export const storeName = 'PICKUP';

export default {
    LOAD_PROVINCES: `${storeName}.LOAD_PROVINCES`,
    LOAD_TOWNS: `${storeName}.LOAD_TOWNS`,
    SET_PROVINCES: `${storeName}.SET_PROVINCES`,
    SET_TOWNS: `${storeName}.SET_TOWNS`,
    SET_PROVINCE: `${storeName}.SET_PROVINCE`,
    SET_TOWN: `${storeName}.SET_TOWN`,
    SET_STORE: `${storeName}.SET_STORE`,
    INITIALIZE: `${storeName}.INITIALIZE`,
    RESET_SELECTIONS: `${storeName}.RESET_SELECTIONS`,
};
